<template>
  <section v-if="!$params.iframe" class="py-12">
    <div class="flex flex-wrap justify-center gap-6" :class="contentWidthClass">
      <article
        v-for="(card, i) in why"
        :key="card.title"
        class="w-80 flex-auto overflow-hidden rounded bg-bgr text-txt shadow"
      >
        <header class="bg-thm pt-4 text-center text-txt-contrast sm:h-36">
          <WebccIcon
            :name="['usp/quality', 'usp/service', 'usp/competence'][i]"
            class="mx-auto h-8 w-8 sm:h-10 sm:w-10"
            :filled="false"
          />
          <h3 class="p-2 text-xl font-light">{{ card.title }}</h3>
        </header>
        <main class="p-4">
          <h4 class="text-center font-semibold">
            {{ card.subtitle || 'Missing in action' }}
          </h4>
          <p class="mt-4 text-center text-base">{{ card.description }}</p>
        </main>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  why: USPCard[]
}>()

const { contentWidthClass } = useContentWidth()
</script>
